import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "commaSeparatedPipe" })
export class CommaSeparatedPipe implements PipeTransform {
  transform(list: any[], property: string): string {
    var commaSeparatedList = "";

    if (list) {
      if (list.length == 1) {
        commaSeparatedList = list[0][property];
      } else if (list.length > 1) {
        var commaSeparatedList = "";
        for (var i = 0; i < list.length; i++) {
          var obj = list[i];
          commaSeparatedList += obj[property];
          if (i !== list.length - 1) {
            commaSeparatedList += ", ";
          }
        }
      }
    }
    return commaSeparatedList;
  }
}
